module.exports = function getResource(label, vars = []) {
    let resources = {
        changeStore: 'Changer de magasin',
        viewDetails: 'Voir les détails',
        getDirections: 'Obtenir l’itinéraire',
        findASephora: 'Trouver un Sephora',
        happeningAtSephora: 'En cours chez Sephora',
        viewAll: 'Tout afficher',
        openUntil: `Ouvert jusqu’à ${vars[0]}`,
        closed: 'Fermé',
        noStoreNear: `Nous n’avons pas été en mesure de trouver un magasin près de « ${vars[0]} ».`,
        useStore: 'Utilisez ce magasin',
        chooseThisStore: 'Choisissez ce magasin',
        chooseYourStore: 'Choisissez votre magasin',
        reservationNotOffered: 'Réservation non offerte',
        milesAway: ' kilomètres de distance',
        ok: 'OK',
        changeStoreMessage: 'Si des articles à ramasser se trouvent dans votre panier, le lieu du ramassage sera modifié pour le magasin',
        anyPromosRewardsMsg: 'De plus, toute promotion ou récompense dans votre panier d’articles à ramasser en sera retirée. Vous pouvez ajouter des promotions et des récompenses en magasin, s’il y a lieu.'
    };

    return resources[label];
};
